import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  // Direktes Injizieren des OIDC-Security-Services
  private readonly oidcSecurityService = inject(OidcSecurityService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Token nicht an /login-Requests anhängen
   /* if (request.url.includes('/login')) {
      return next.handle(request);
    }*/

    // Den Access-Token asynchron vom Security Service holen.
    return this.oidcSecurityService.getAccessToken().pipe(
      take(1), // Nur den ersten Wert nehmen und danach den Stream abschließen.
      switchMap(token => {
        // Wenn ein Token vorhanden ist, den Request klonen und den Header setzen.
        if (token) {
          request = this.addToken(request, token);
        }
        // Den (ggf. modifizierten) Request weiterreichen.
        return next.handle(request);
      })
    );
  }

  /**
   * Klont den Request und fügt den Authorization-Header mit dem Bearer Token hinzu.
   * @param request Der Original-HTTP-Request.
   * @param token Das Access-Token.
   * @returns Den geklonten Request mit gesetztem Header.
   */
  private addToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }
}
